// ── 카드전화승인 탭 콘텐츠 ────────────────────────────────────────────────────
import React from 'react';
import { FilterBar } from './FilterBar';
import {
  fmtNum, fmtDate,
  tblWrap, thStyle, tdStyle, rowCells,
  btnPrimary, btnSecondary, btnEdit, btnDanger, btnGroup,
} from './styles';

/**
 * 카드전화승인 탭 콘텐츠
 * Props:
 *   phoneApps
 *   filterStart, setFilterStart, filterEnd, setFilterEnd
 *   loadPhoneApps
 *   setModal, handleDelete
 */
export function TabPhone({
  phoneApps,
  filterStart, setFilterStart, filterEnd, setFilterEnd,
  loadPhoneApps,
  setModal, handleDelete,
  auditTableName = 'revenue_card_phone_approvals', // 감사 로그 테이블명 (DOT/EXT는 다른 값 전달)
}) {
  // 기간 내 총 결제 합계
  const total = phoneApps.reduce((s, r) => s + Number(r.amount || 0), 0);

  return (
    <>
      {/* 필터 바 + 버튼 영역 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 8 }}>
        <FilterBar
          filterStart={filterStart} setFilterStart={setFilterStart}
          filterEnd={filterEnd}     setFilterEnd={setFilterEnd}
          onSearch={loadPhoneApps}
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={btnPrimary}
            onClick={() => setModal({ type: 'phone', data: null })}>
            + 등록
          </button>
          <button style={btnSecondary}
            onClick={() => setModal({ type: 'auditlog', tableName: auditTableName, title: '카드전화승인' })}>
            이력
          </button>
        </div>
      </div>

      {/* 건수 / 합계 요약 */}
      <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 8 }}>
        총 {phoneApps.length}건 / 합계 <strong>{fmtNum(total)}</strong>원
      </div>

      {/* 테이블 */}
      <div style={tblWrap}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['결제일','카드사'].map((h) => <th key={h} style={thStyle}>{h}</th>)}
              {/* 결제금액: 금액이 길어질 수 있어 고정 너비 */}
              <th style={{ ...thStyle, width: 96 }}>결제금액</th>
              {['할부','마케터','비고',''].map((h) => <th key={h} style={thStyle}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {phoneApps.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...tdStyle, borderBottom: 'none', textAlign: 'center', color: 'var(--text-muted)' }}>
                  데이터 없음
                </td>
              </tr>
            )}
            {phoneApps.map((r, i) => {
              const c = rowCells(i, phoneApps.length); // 마지막 행 밑줄 제거
              return (
              <tr key={r.id}>
                <td style={c.td}>{fmtDate(r.payment_date)}</td>
                <td style={c.td}>{r.card_company}</td>
                <td style={{ ...c.amt, whiteSpace: 'normal', width: 96 }}>{fmtNum(r.amount)}원</td>
                <td style={{ ...c.td, textAlign: 'center' }}>
                  {r.installment_months > 0 ? `${r.installment_months}개월` : '일시불'}
                </td>
                <td style={c.td}>{r.user_name || '-'}</td>
                <td style={c.td}>{r.note || '-'}</td>
                <td style={c.btn}>
                  <div style={btnGroup}>
                    <button style={btnEdit}
                      onClick={() => setModal({ type: 'phone', data: r })}>수정</button>
                    <button style={btnDanger}
                      onClick={() => handleDelete('card-phone-approvals', r.id, '카드전화승인')}>삭제</button>
                  </div>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
